import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { ConnectPage } from './features/connect';
import { ImpactPage, loadLocationMetrics } from './features/impact';
import { LandingPage } from './features/landing';
import { PrivacyPolicyPage, TermsAndConditionsPage } from './features/legal';
import { theme } from './theme';

export default function App() {
  // Kick off the live location-metrics load once at app start; hover/tooltip
  // data falls back to bundled data automatically until (or unless) it
  // resolves — see services/locationMetricsService.
  useEffect(() => {
    void loadLocationMetrics();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
